/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthChallengeResponse as ModelsAuthenticationAuthChallengeResponse } from '../models/Models/Authentication/auth-challenge-response';
import { AuthLoginResponse as ModelsAuthenticationAuthLoginResponse } from '../models/Models/Authentication/auth-login-response';
import { AuthTokenResponse as ModelsAuthenticationAuthTokenResponse } from '../models/Models/Authentication/auth-token-response';
import { v4TokenAuthorizePost$Json$Json } from '../fn/token-authorization/v-4-token-authorize-post-json-json';
import { V4TokenAuthorizePost$Json$Json$Params } from '../fn/token-authorization/v-4-token-authorize-post-json-json';
import { v4TokenAuthorizePost$Json$Plain } from '../fn/token-authorization/v-4-token-authorize-post-json-plain';
import { V4TokenAuthorizePost$Json$Plain$Params } from '../fn/token-authorization/v-4-token-authorize-post-json-plain';
import { v4TokenAuthorizePost$Json$Xml } from '../fn/token-authorization/v-4-token-authorize-post-json-xml';
import { V4TokenAuthorizePost$Json$Xml$Params } from '../fn/token-authorization/v-4-token-authorize-post-json-xml';
import { v4TokenAuthorizePost$Xml$Json } from '../fn/token-authorization/v-4-token-authorize-post-xml-json';
import { V4TokenAuthorizePost$Xml$Json$Params } from '../fn/token-authorization/v-4-token-authorize-post-xml-json';
import { v4TokenAuthorizePost$Xml$Plain } from '../fn/token-authorization/v-4-token-authorize-post-xml-plain';
import { V4TokenAuthorizePost$Xml$Plain$Params } from '../fn/token-authorization/v-4-token-authorize-post-xml-plain';
import { v4TokenAuthorizePost$Xml$Xml } from '../fn/token-authorization/v-4-token-authorize-post-xml-xml';
import { V4TokenAuthorizePost$Xml$Xml$Params } from '../fn/token-authorization/v-4-token-authorize-post-xml-xml';
import { v4TokenGet$Json } from '../fn/token-authorization/v-4-token-get-json';
import { V4TokenGet$Json$Params } from '../fn/token-authorization/v-4-token-get-json';
import { v4TokenGet$Plain } from '../fn/token-authorization/v-4-token-get-plain';
import { V4TokenGet$Plain$Params } from '../fn/token-authorization/v-4-token-get-plain';
import { v4TokenGet$Xml } from '../fn/token-authorization/v-4-token-get-xml';
import { V4TokenGet$Xml$Params } from '../fn/token-authorization/v-4-token-get-xml';
import { v4TokenPost$Json$Json } from '../fn/token-authorization/v-4-token-post-json-json';
import { V4TokenPost$Json$Json$Params } from '../fn/token-authorization/v-4-token-post-json-json';
import { v4TokenPost$Json$Plain } from '../fn/token-authorization/v-4-token-post-json-plain';
import { V4TokenPost$Json$Plain$Params } from '../fn/token-authorization/v-4-token-post-json-plain';
import { v4TokenPost$Json$Xml } from '../fn/token-authorization/v-4-token-post-json-xml';
import { V4TokenPost$Json$Xml$Params } from '../fn/token-authorization/v-4-token-post-json-xml';
import { v4TokenPost$Xml$Json } from '../fn/token-authorization/v-4-token-post-xml-json';
import { V4TokenPost$Xml$Json$Params } from '../fn/token-authorization/v-4-token-post-xml-json';
import { v4TokenPost$Xml$Plain } from '../fn/token-authorization/v-4-token-post-xml-plain';
import { V4TokenPost$Xml$Plain$Params } from '../fn/token-authorization/v-4-token-post-xml-plain';
import { v4TokenPost$Xml$Xml } from '../fn/token-authorization/v-4-token-post-xml-xml';
import { V4TokenPost$Xml$Xml$Params } from '../fn/token-authorization/v-4-token-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class TokenAuthorizationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4TokenGet()` */
  static readonly V4TokenGetPath = '/v4/token';

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Plain$Response(params?: V4TokenGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v4TokenGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Plain(params?: V4TokenGet$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v4TokenGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Json$Response(params?: V4TokenGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v4TokenGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Json(params?: V4TokenGet$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v4TokenGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Xml$Response(params?: V4TokenGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>> {
    return v4TokenGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the access token using a valid refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4TokenGet$Xml(params?: V4TokenGet$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthTokenResponse> {
    return this.v4TokenGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthTokenResponse>): ModelsAuthenticationAuthTokenResponse => r.body)
    );
  }

  /** Path part for operation `v4TokenPost()` */
  static readonly V4TokenPostPath = '/v4/token';

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Plain$Response(params?: V4TokenPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Plain(params?: V4TokenPost$Json$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Json$Response(params?: V4TokenPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Json(params?: V4TokenPost$Json$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Xml$Response(params?: V4TokenPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenPost$Json$Xml(params?: V4TokenPost$Json$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Plain$Response(params?: V4TokenPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Plain(params?: V4TokenPost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Json$Response(params?: V4TokenPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Json(params?: V4TokenPost$Xml$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenPost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Xml$Response(params?: V4TokenPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>> {
    return v4TokenPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Login and get refresh token.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenPost$Xml$Xml(params?: V4TokenPost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthLoginResponse> {
    return this.v4TokenPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthLoginResponse>): ModelsAuthenticationAuthLoginResponse => r.body)
    );
  }

  /** Path part for operation `v4TokenAuthorizePost()` */
  static readonly V4TokenAuthorizePostPath = '/v4/token/authorize';

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Plain$Response(params?: V4TokenAuthorizePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Plain(params?: V4TokenAuthorizePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Json$Response(params?: V4TokenAuthorizePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Json(params?: V4TokenAuthorizePost$Json$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Xml$Response(params?: V4TokenAuthorizePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4TokenAuthorizePost$Json$Xml(params?: V4TokenAuthorizePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Plain$Response(params?: V4TokenAuthorizePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Plain(params?: V4TokenAuthorizePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Json$Response(params?: V4TokenAuthorizePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Json(params?: V4TokenAuthorizePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4TokenAuthorizePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Xml$Response(params?: V4TokenAuthorizePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
    return v4TokenAuthorizePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authorize - Get the auth code for the challenge verification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4TokenAuthorizePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4TokenAuthorizePost$Xml$Xml(params?: V4TokenAuthorizePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsAuthenticationAuthChallengeResponse> {
    return this.v4TokenAuthorizePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>): ModelsAuthenticationAuthChallengeResponse => r.body)
    );
  }

}
